<div class="grid gap-4 h-full" style="grid-template-columns: 240px 280px 1fr;">
  <app-source-type-sidebar></app-source-type-sidebar>
  <app-template-list-panel></app-template-list-panel>
  <app-template-rules-panel></app-template-rules-panel>
</div>
